import { Box, IconButton, InputAdornment, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent.js"
import Iconify from "minimals-template/components/Iconify.js"

// a simple search bar state-setter without debounce, doesn't own its state
// style mirrors select-schedule list search bar
export function TailoredScheduleBrowserSearchBar({ state, stateSetter }) {
    return (
        <Box py={2} m="auto" width={1}>
            <TextField
                fullWidth
                aria-label="Filter by name or code"
                className="model-filter"
                variant="standard"
                value={state}
                onChange={setFromEvent(stateSetter)}
                inputProps={{ "data-cy": "tailored-schedule-search" }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton className="clear-button" aria-label="Clear search" size="small" onClick={clear}>
                                <Iconify icon="ic:round-clear" />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                placeholder="Filter by name or code..."
            />
        </Box>
    )

    function clear() {
        stateSetter("")
    }
}
